const decoder = new TextDecoder('iso8859-1');

export function xrfParserPanalytical(blob) {
  let text = decoder.decode(blob);

  let lines = text.split(/\r?\n/);
  let meta = {};
  let headers;
  let data = [];
  let variables = {};
  for (let line of lines) {
    if (line.includes(':')) {
      let fields = line.split(/ +: +/);
      let value = fields.slice(1).join(':');
      let numberValue = value.replaceAll(',', '.');
      meta[fields[0]] = Number.isNaN(Number(numberValue))
        ? value
        : Number.parseFloat(numberValue);
    } else if (line.match(/^[A-Z]/)) {
      // header of tables
      headers = line.split(/\t/);
    } else if (line.match(/^\s*$/)) {
      // skip this line
    } else {
      data.push(
        line
          .split(/\t/)
          .map((field) => Number.parseFloat(field.replace(',', '.'))),
      );
    }
  }
  for (let i = 0; i < headers.length; i++) {
    let id;
    switch (i) {
      case 0:
        id = 'X';
        break;
      case 1:
        id = 'Y';
        break;
      default:
        id = String.fromCodePoint(63 + i);
    }
    let units = headers[i].split('(')[1];
    units = units ? units.replace(')', '') : '';
    variables[id] = {
      label: headers[i].replace(/ \(.*/, ''),
      units,
      data: data.map((datum) => datum[i]),
    };
  }
  return { meta, variables };
}
